import React, { Component } from 'react';
import adsService from '../../services/ad';
import { Carousel } from 'react-responsive-carousel';
import './index.css';

export default class AdsSlider extends Component {
  state = {
    ads: []
  };

  componentWillMount() {
    this.getAds();
  }

  getAds() {
    return adsService.data({
      position: this.props.position
    })
    .then(this.updateAds.bind(this))
    .catch(this.showErr.bind(this));
  }

  updateAds(ads) {
    this.setState({
      ads: ads
    })
  }

  showErr(err) {

  }

  openInNewTab(url) {
    if (url) {
      let win = window.open(url, '_blank');
      win.focus();
    }
  }

  renderAds() {
    return this.state.ads.map((ad, index) => {
      if (ad.url && ad.url.replace) { ad.url = ad.url.replace('http://', 'https://'); }
      return (
        <div className="image" onClick={this.openInNewTab.bind(this, ad.link)} style={{backgroundImage:`url(${ad.url})`}} key={`ad-${index}`}></div>
      )
    });
  }

  render() {
    let rendered = null;

    if (this.state.ads && this.state.ads.length > 0) {
      let carouselProps = {
        showThumbs: false,
        autoPlay: true,
        infiniteLoop: true,
        interval: 5000
      };

      let ads = this.renderAds();

      rendered = (
        <Carousel {...carouselProps}>
          {ads}
        </Carousel>
      );
    }

    return (
      <div className="comp-adsSlider">
        {rendered}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/adsSlider/index.js